// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;24</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;The earth is the Lord&#146;s and all that fills it,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the compass of the world and all who dwell therein.<br> </p> </div></div>";
// Exports
module.exports = code;